/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { SectionShell } from '../../atoms/SectionShell/SectionShell';
import type { ProcessSectionProps } from './ProcessSection.types';

export const ProcessSection = ({ topic, className }: ProcessSectionProps) => {
  const { t } = useInt();

  if (!topic.workflow?.trim()) {
    return null;
  }

  const paragraphs = topic.workflow.split('\n\n');

  return (
    <SectionShell id="process" title={t('How to assess it in practice')} className={className}>
      {paragraphs.map((paragraph, i) => (
        <p key={i}>{paragraph}</p>
      ))}
    </SectionShell>
  );
};
